import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { handleAxiosError } from "../../../config/action-config";
import { getHolidayById } from "../../../api/holidays";
import ViewHolidayDetail from "./view.holiday.detail";
const emptyNewHolidayData = {
  occasion: "",
  date_of_holiday: "",
  holiday_day: "",
  holiday_type: "",
};

export default function ViewCustomHoliday() {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(null);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);
  async function loadMasterData() {
    try {
      const { data } = await getHolidayById(params.id, user.token);

      setData(data.data[0]);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return data ? (
    <ViewHolidayDetail preloadedValues={data} refresh={loadMasterData} />
  ) : (
    <div className="center">Loading.....</div>
  );
}
